import { render, staticRenderFns } from "./DisplayBarrels.vue?vue&type=template&id=52168b39"
import script from "./DisplayBarrels.vue?vue&type=script&lang=js"
export * from "./DisplayBarrels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports